'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bicycle';
var width = 640;
var height = 512;
var aliases = [128690];
var unicode = 'f206';
var svgPathData = ['M48 352c0 53 43 96 96 96 47.6 0 87.1-34.6 94.7-80l-97.5 0c-14.3 0-23.6-15-17.2-27.8l41-81.9c-6.7-1.5-13.8-2.3-21-2.3-53 0-96 43-96 96zm352.3-7.7c-.2 2.5-.2 5-.3 7.6 0 2.7 .1 5.5 .3 8.2 4.2 49.3 45.4 87.9 95.6 87.9 53 0 96-43 96-96s-43-96-96-96c-10.5 0-20.5 1.7-29.9 4.8l44.1 83.8 7.4 14.2-28.3 14.9-7.5-14.2-44.1-83.8c-21 16.1-35.2 40.6-37.4 68.7z', 'M309.5 32l154.5 0 0 32-101.5 0 88.5 168.1c14-5.3 29.2-8.1 45-8.1 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-43.4 21.6-81.8 54.7-104.9l-20.7-39.3-75.7 151.4-4.4 8.8-50.9 0c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128S73.3 224 144 224c12.4 0 24.3 1.8 35.6 5l26.5-53-24-48-54.1 0 0-32 73.9 0 4.4 8.8 27.6 55.2 143 0C333.1 76.8 310.6 34.1 309.5 32zM224 211.8L161.9 336 286.1 336 224 211.8zm88 104.4L374.1 192 249.9 192 312 316.2zm169.8 43.2l-44.1-83.8c-23 17.5-37.8 45.2-37.8 76.3 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-10.5 0-20.5 1.7-29.9 4.8l44.1 83.8 7.4 14.2-28.3 14.9-7.5-14.2zM144 448c47.6 0 87.1-34.6 94.7-80l-97.5 0c-14.3 0-23.6-15-17.2-27.8l41-81.9c-6.7-1.5-13.8-2.3-21-2.3-53 0-96 43-96 96s43 96 96 96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBicycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;